module.exports = __webpack_public_path__ + "assets/img/19_857.cd5081a1.jpg";